
































































































/* eslint-disable */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class ComponentProducaoDadosIniciais extends Vue {
  @Prop(Boolean) isEdit
  @Prop(Object) producao
  @Prop(Array) negociacoes

  fontesPagadoras: Array<any> = []
  locaisExecucao: Array<any> = []
  operadorasPlano: Array<any> = []

  fontesPagadoraId: any = null
  localExecucaoId: any = null
  operadoraPlanoId: any = null
  operadoraId: any = null
  operadoraPlano: String = ''

  get target () {
    const value = '#rowOperadoraPlano'
    return value
  }

  mounted() {
    this.getFontesPagadoras()
  }

  getFontesPagadoras() {
    this.fontesPagadoras = this.negociacoes
  }

  getLocaisExecucao() {
    this.negociacoes.map((negociacao) => {
      if (negociacao.id == this.fontesPagadoraId) {
        this.locaisExecucao = negociacao.locaisExecucao
      }
    })
  }

  getOperadorasPlano() {
    const operadorasPlano: any = []

    this.locaisExecucao.map((local) => {
      if (local.id == this.localExecucaoId) {
        local.negociacoes.map((negociacao) => {
          let separator = ''

          if (negociacao.planoEmpresa) {
            separator = '/'
          }

          operadorasPlano.push({
            ...negociacao,
            operadoraPlano: `${negociacao.nomeOperadora} ${separator} ${negociacao.planoEmpresa}`,
          })
        })
      }
    })

    this.operadorasPlano = operadorasPlano
  }

  setOperadoraPlano() {
    if (this.producao.negociacao && this.producao.negociacao.planoEmpresa) {
      this.operadoraPlano = `${this.producao.operadora.nome} / ${this.producao.negociacao.planoEmpresa}`
    } else {
      this.operadoraPlano = `${this.producao.operadora.nome}`
    }
  }

  operadoraPlanoFocus() {
    const body: any = document.querySelector('body')
    const noOverflowClass = 'wrap-scroll'

    body.classList.add(noOverflowClass)
  }

  operadoraPlanoBlur() {
    const body: any = document.querySelector('body')
    const noOverflowClass = 'wrap-scroll'

    body.classList.remove(noOverflowClass)
  }


  @Watch('producao.negociacao')
  onProducaoNegociacaoChange() {
    this.setOperadoraPlano()
  }

  @Watch('fontesPagadoraId')
  onFontesPagadoraIdChange() {
    this.getLocaisExecucao()
    this.localExecucaoId = null;
    this.operadoraPlanoId = null
    this.producao.fontePagadora.identificador = this.fontesPagadoraId
  }

  @Watch('localExecucaoId')
  onLocalExecucaoIdChange() {
    this.getOperadorasPlano()
    this.operadoraPlanoId = null
    this.producao.localExecucao.identificador = this.localExecucaoId
  }

  @Watch('negociacoes')
  onNegociacoesChange() {
    this.fontesPagadoras = this.negociacoes
  }

  @Watch('operadora')
  onOperadoraChange() {
    this.setOperadoraPlano()
  }

  @Watch('operadoraPlanoId')
  nnOperadoraPlanoIdChange() {
    this.producao.idNegociacao = this.operadoraPlanoId.id

    this.operadorasPlano.map((operadora) => {
      this.producao.operadora.identificador = this.operadoraPlanoId.operadoraId
    })
  }

  @Watch('producao')
  onProducaoChange() {
    this.setOperadoraPlano()
  }

}
